export default __webpack_public_path__ + "static/media/mp3.8e5adec3.svg";